import script from "./PaymentServiceInstruction.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentServiceInstruction.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentServiceInstruction.vue?vue&type=style&index=0&id=751206cc&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-751206cc"]])

export default __exports__